
  import FacultyDetail from "@/components/FacultyDetail.vue";
  import { Vue, Component } from "vue-property-decorator";

  @Component({
    components: {
      FacultyDetail,
    },
  })
  export default class MichaelCrary extends Vue {
    michael = {
      name: "Michael A. Crary",
      image: require("@/assets/faculty-mike.png"),
      title: "Ph.D, FASHA, Honors ASHA, CCC&#8209;SLP",
      description:
        "Dr Crary retired from university life after a career of nearly 45 years. During that time he remained an active clinician and clinical researcher. Committed to continuing to support clinical research efforts Dr.  Crary’s current clinical and research interests focus on swallowing disorders, specifically improving assessment and treatment strategies. Current research projects include studies of the characteristics of dysphagia and related morbidities in stroke patients, community dwelling older persons, outcomes of dysphagia treatment in patients with head/neck cancer or stroke, and outcomes associated with exercised-based therapy and adjunctive modalities in the treatment of dysphagia in adult patients. His most recent text is “Dysphagia Management in Adults and Children” with Michael Groher (3rd edition 2020). Dr. Crary is a Fellow of ASHA and has served in the board of SIG 13. He was awarded Honors of the Association in 2016.",
    };
  }
